import { gsap } from "@/vendor/gsap";
import { ScrollTrigger } from "@/vendor/gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const init = () => {

    const textSectionMediaElements = gsap.utils.toArray(
        ".section-text-media.section-text-media--media-position-mediaRight.section-text-media--media-expansion-grid .media, .section-text-on-image .media",
    );

    console.log(textSectionMediaElements)
    textSectionMediaElements.forEach(function(elem){

        elem.style.transformOrigin="top center";
        // elem.addEventListener(eventType, () => {

            gsap.fromTo(elem,
                {
                    scale: 1.5
                    // 'width': '100vw',
                    // 'left': '50%',
                    // 'x': '-50vw',
                },
                {
                    scrollTrigger: {
                        trigger: elem,
                        scrub: true,
                        start: 'top 80%',
                        end: 'center center',
                        invalidateOnRefresh: true
                    },
                    scale: 1
                    // 'width': '100%',
                    // 'left': '50%',
                    // 'x': '-50%',
                }
            );
        // })
    });

}

export default init;
